var _path, _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetServicesOverdueEmptystate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 110,
    viewBox: "0 0 114 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 74H89.5C107 74 114 67 114 49.5V28.5C114 11 107 4 89.5 4H68.5C51 4 44 11 44 28.5V49.5C44 67 51 74 68.5 74Z",
    fill: "url(#paint0_linear_5869_13732)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5869_13732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 90H65.5C83 90 90 83 90 65.5V44.5C90 27 83 20 65.5 20H44.5C27 20 20 27 20 44.5V65.5C20 83 27 90 44.5 90Z",
    fill: "url(#paint1_linear_5869_13732)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5869_13732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 90H63.5C81 90 88 83 88 65.5V44.5C88 27 81 20 63.5 20H42.5C25 20 18 27 18 44.5V65.5C18 83 25 90 42.5 90Z",
    fill: "url(#paint2_linear_5869_13732)",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_5869_13732)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9072 24.9072C27.0541 20.7602 33.426 19 42.25 19H63.25C72.074 19 78.4459 20.7602 82.5928 24.9072C86.7398 29.0541 88.5 35.426 88.5 44.25V65.25C88.5 74.074 86.7398 80.4459 82.5928 84.5928C78.4459 88.7398 72.074 90.5 63.25 90.5H42.25C33.426 90.5 27.0541 88.7398 22.9072 84.5928C18.7602 80.4459 17 74.074 17 65.25V44.25C17 35.426 18.7602 29.0541 22.9072 24.9072ZM23.9678 25.9678C20.2398 29.6959 18.5 35.574 18.5 44.25V65.25C18.5 73.926 20.2398 79.8041 23.9678 83.5322C27.6959 87.2602 33.574 89 42.25 89H63.25C71.926 89 77.8041 87.2602 81.5322 83.5322C85.2602 79.8041 87 73.926 87 65.25V44.25C87 35.574 85.2602 29.6959 81.5322 25.9678C77.8041 22.2398 71.926 20.5 63.25 20.5H42.25C33.574 20.5 27.6959 22.2398 23.9678 25.9678Z",
    fill: "url(#paint3_linear_5869_13732)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5869_13732)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 55C37 46.1634 44.1634 39 53 39C61.8366 39 69 46.1634 69 55C69 63.8366 61.8366 71 53 71C44.1634 71 37 63.8366 37 55ZM54.4545 46.2727C54.4545 45.4694 53.8033 44.8182 53 44.8182C52.1967 44.8182 51.5455 45.4694 51.5455 46.2727V55C51.5455 55.5509 51.8567 56.0546 52.3495 56.301L58.1677 59.2101C58.8862 59.5693 59.7599 59.2781 60.1192 58.5596C60.4784 57.8411 60.1872 56.9674 59.4687 56.6081L54.4545 54.101V46.2727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5869_13732",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_5869_13732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5869_13732",
    x: 2,
    y: 4,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5869_13732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5869_13732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_5869_13732",
    x: 1,
    y: 3,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5869_13732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5869_13732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5869_13732",
    x: 37,
    y: 39,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5869_13732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5869_13732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5869_13732",
    x1: 49,
    y1: 11,
    x2: 102,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5869_13732",
    x1: 25,
    y1: 27,
    x2: 78,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5869_13732",
    x1: 23,
    y1: 27,
    x2: 76,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5869_13732",
    x1: 80.75,
    y1: 25.75,
    x2: 23.75,
    y2: 84.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetServicesOverdueEmptystate);
export default __webpack_public_path__ + "static/media/asset-services-overdue-emptystate.dff3a5244fc75d0218bdb560a55bbf7b.svg";
export { ForwardRef as ReactComponent };